import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/evento/tipo_evento_campos${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/evento/tipo_evento_campos', data)
  },
  edit(data) {
    return axios.put(`/evento/tipo_evento_campos/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/evento/tipo_evento_campos/${id}`)
  },
}
